import { createApp } from 'vue'
import { Howl, Howler } from 'howler'
import App from './App.vue'
import router from './router'
import { createDeviceDetector } from 'next-vue-device-detector'
import { VueCookieNext } from 'vue-cookie-next'
import i18n from './i18n'
import VueKonva from 'vue-konva'
import { getObjectValue } from './functions/string/getObjectValue'
import { saveUserInfo } from './functions/apis'
import { ensureUniWebview } from '@/functions/installUniWebview'
import 'vant/lib/index.css';

/** svgaplayerweb 2.3+：带音效的 .svga 会在解析到音频轨时 `new Howl(...)`，依赖全局 Howl（见 node_modules/svgaplayerweb/src/Canvas/renderer.js） */
const w = window as Window & { Howl?: typeof Howl; Howler?: typeof Howler }
w.Howl = Howl
w.Howler = Howler

// set default config
VueCookieNext.config({ expire: '7d' });

router.beforeEach((to: any, from: any, next: any) => {
    const title = getObjectValue(to, 'meta', 'title', '');
    if (
        (typeof title == 'string' && '' != title) ||
        typeof title == 'number'
    ) {
        document.title = title+"";
    }
    const query = getObjectValue(to, 'query', {});
    const loginUid = query['loginUid'];
    const loginToken = query['loginToken'];
    if (
        typeof query == 'object' && null != query &&
        typeof loginUid == 'string' && '' != (loginUid+'').trim() &&
        typeof loginToken == 'string' && '' != (loginToken+'').trim()
    ) {
        saveUserInfo(loginUid, loginToken, {
            success: () => {
                const nextQuery = Object.assign({}, query);
                delete nextQuery['loginUid'];
                delete nextQuery['loginToken'];
                next({ path: to.path, query: nextQuery, hash: to.hash, replace: true });
            },
            fail: () => {
                next();
            }
        });
        return;
    }
    next();
});
const device = createDeviceDetector();
const app = createApp(App);
app.config.globalProperties.$ensureUniWebview = ensureUniWebview;
app.use(i18n).use(device)
.use(VueKonva)
.use(VueCookieNext).use(router).mount('#app');
